import { useEffect, useRef, useState } from 'react'

import { Scrollbar } from 'smooth-scrollbar/interfaces'

import { useSmoothScroll } from '@/store/smoothScroll'

export const useIsVisibleElement = () => {
  const { defaultElement, getScrollbar } = useSmoothScroll()

  const element = useRef<HTMLDivElement>(null)
  const scrollbar = useRef<Scrollbar | undefined>()
  const [elementVisible, setElementVisible] = useState(false)

  useEffect(() => {
    scrollbar.current = getScrollbar(document.getElementById(defaultElement))
    const onScroll = () => {
      if (!element.current) return
      const positions = element.current.getBoundingClientRect()
      const start = positions.top
      const end = positions.bottom

      if (start >= 0 && end <= window.innerHeight * 1.3) {
        setElementVisible(true)
      }
    }

    scrollbar.current?.addListener(onScroll)

    return () => scrollbar.current?.removeListener(onScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { element, elementVisible, scrollbar }
}
